/**
 * @memberof activerecord
 * @property {boolean} isDeleting
 * @property {boolean} isLoading
 * @property {boolean} isSaving
 */
class ActiveRecordStatus {
    constructor() {
        this.isDeleting = false;
        this.isLoading = false;
        this.isSaving = false;
    }
    /**
     * @property {boolean}
     */
    get isWorking() {
        return this.isDeleting || this.isLoading || this.isSaving;
    }
}
export default ActiveRecordStatus;
